import React from 'react';
import { CircleBadge, CircleBadgeColor } from '../../../../CircleBadge';
import { HourGlass } from '../../../../Icons';
import ReactTooltip from 'react-tooltip';

interface InProgressBadgeProps {
  id: string;
  startedDates: string[];
  columnName: string;
}
const InProgressBadge = ({
  id,
  startedDates,
  columnName,
}: InProgressBadgeProps) => {
  const child = startedDates.length > 1 ? `${startedDates.length}` : HourGlass;

  return (
    <>
      <CircleBadge
        child={child}
        color={CircleBadgeColor.YELLOW}
        dataFor={`in-progress-badge-${id}`}
        dataTip
      />
      <ReactTooltip id={`in-progress-badge-${id}`} effect="solid">
        <div className="mb-1">{`In progress ${columnName}`}</div>
        <div className="mb-1">
          {startedDates.map((dateStr, index) => (
            <div className="mb-1" key={`completed-badge-${id}-${index}`}>
              {dateStr}
              <br />
            </div>
          ))}
        </div>
      </ReactTooltip>
    </>
  );
};

export default InProgressBadge;
